import { View } from "@/components/ui";
import { WebLayout } from "@/components/shared/layout/homepage.web";
import { Column, Container } from "@/components/ui/layout";

import { CsatCardForm } from "@/containers/csat/csat-card-form";
import { ROUTES } from "@/constants/routes";
import { Navigate, useSearchParams } from "react-router-dom";

export const CsatRatePage = () => {
  const [searchParams] = useSearchParams();

  if (!searchParams.get("token")) {
    return <Navigate to={ROUTES.Root} />;
  }

  return (
    <WebLayout>
      <Container gap="xl" center>
        <Column desktop="6">
          <View className="md:my-10">
            <CsatCardForm token={searchParams.get("token") as string} />
          </View>
        </Column>
      </Container>
    </WebLayout>
  );
};
